import * as m from "../../es2015/plugins/sliceGrouper";
window.am4plugins_sliceGrouper = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/sliceGrouper.js
// module id = null
// module chunks = 